<template>
  <div>
    <md-card>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-33 md-xsmall-size-100">
            <md-field>
              <label>Seleccione un almacén</label>
              <md-select v-model="warehouse" name="warehouse" id="warehouse">
                <md-option
                  v-for="item in fetchedWarehouses"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <div
      v-if="warehouse && loading"
      style="width: 100%"
      class="md-layout md-alignment-center-center"
    >
      <md-progress-spinner
        :md-diameter="100"
        :md-stroke="10"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
    <md-card
      class="provider-form"
      v-else-if="warehouse && !loading && !!tableData.length"
    >
      <md-card-header style="padding: 0px 10px">
        <h4><strong>Proveedor</strong></h4>
      </md-card-header>
      <md-card-content style="padding: 0px 10px" class="md-layout">
        <div class="md-layout-item md-size-100 md-xsmall-size-100">
          <label class="label-tag">Seleccione los proveedores:</label>
          <multiselect
            v-model="dataProvider"
            :options="providers"
            :multiple="true"
            placeholder=""
            track-by="commercial_name"
            label="commercial_name"
            tag-position="bottom"
            selectLabel="Seleccionar proveedor"
            selectedLabel="Seleccionado"
            deselectLabel="Eliminar seleccionado"
            :close-on-select="false"
          >
            <template slot="noResult">
              <strong>Proveedor no encontrado.</strong>
            </template>
            <template slot="noOptions">
              <strong>No se encontraron proveedores.</strong>
            </template>
            <div class="custom-tags" slot-scope="{ option, remove }" slot="tag">
              <span class="custom-tags__tag">
                <strong>{{ option.provider_number }}</strong>
                <span class="remove-tag" @click="remove(option)"> ❌ </span>
              </span>
            </div>
            <div slot-scope="{ option }" slot="option">
              <strong> {{ option.commercial_name }} </strong>
              <div>
                <span>
                  <strong>Número:</strong> {{ option.provider_number }}
                </span>
                <br />
              </div>
            </div>
          </multiselect>
        </div>
        <div class="md-layout-item md-size-50 md-xsmall-size-100">
          <div class="outlined-field">
            <md-field>
              <label>Condiciones de pago</label>
              <md-input
                type="text"
                v-model="paymentConditions"
                required
              ></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout-item md-size-50 md-xsmall-size-100">
          <div class="outlined-field">
            <md-field>
              <label>Condiciones de entrega</label>
              <md-input
                type="text"
                v-model="deliveryConditions"
                required
              ></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button
          class="md-danger"
          :disabled="disableRejectBtn"
          @click="rejectMaterials"
        >
          Rechazar
        </md-button>
        <md-button
          class="md-primary"
          :disabled="disabledQuo"
          @click="sendMailToProveedor"
        >
          cotizar
        </md-button>
      </md-card-actions>
    </md-card>
    <table-actions
      v-show="warehouse !== '' && !loading"
      title="Seleccione insumos para cotización"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :hasActions="false"
      :actions="tableActions"
      @selected="selected"
    ></table-actions>
  </div>
</template>
<script>
import catalogService from "@/services/catalog";
import quotationService from "@/services/purchase/quotation";
import warehouseService from "@/services/purchase/warehouse";
import TableActions from "./TableActions";
import warehouseRouteMixin from "./../warehouseRouteMixin";

export default {
  components: { TableActions },
  mixins: [warehouseRouteMixin],
  data() {
    return {
      warehouse: "",
      fetchedWarehouses: [],
      supplyFamilies: [
        {
          id: 0,
          name: "Todos",
        },
      ],
      supplyFamily: "0",
      dataProvider: [],
      providers: [],
      tableData: [],
      tableHeaders: {
        supplyCode: "Código",
        supplyName: "Insumo",
        supplyFamily: "Familia",
        quantity: "Cantidad",
        supplyPrice: "PU",
        highway: "Autopista",
        sinRequisitionNumber: "Requisición"
      },
      tableActions: [],
      selectedElements: [],
      paymentConditions: null,
      loading: true,
      deliveryConditions: null,
      titleMail: false,
    };
  },
  methods: {
    selected(elements) {
      this.selectedElements = elements;
    },
    fetchConsolidated(warehouse) {
      this.loading = true;
      quotationService
        .fetchConsolidated(warehouse)
        .then((response) => {
          this.tableData = response;
          this.dataProvider = [];
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.loading = false));
    },
    rejectMaterials() {
      const suppliesList = this.selectedElements.map((e) => { return { id: e.id } })
      const payload = {
        comment: '',
        supply_refused: suppliesList
      }
      this.$fire({
        html: `<strong>Rechazo de materiales</strong>`,
        title: "Escribe el motivo",
        input: "text",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
      }).then(({ value }) => {
        if (value) {
          payload.comment = value;
          quotationService.sendRejectedQuotations(payload)
            .then(() => {
              this.$successMessage({ title: "El material se rechazó correctamente" });
              this.fetchConsolidated(this.warehouse)
              this.selectedElements = []
            }) 
            .catch(this.$fireErrorResponse)
        }
      });
    },
    sendConsolidated(titleMail, sendMail) {
      const promise = new Promise((resolve) => {
        this.titleMail = titleMail;
        let consolidated = [];
        for (let i = 0; i < this.selectedElements.length; i++) {
          consolidated[i] = this.selectedElements[i].id;
        }
        const dataProviderIds = this.dataProvider.map((p) => p.id);
        let payload = {
          warehouse: this.warehouse,
          materials: consolidated,
          providers: dataProviderIds,
          payment_conditions: this.paymentConditions,
          delivery_conditions: this.deliveryConditions,
          send_mail: sendMail,
        };
        quotationService
          .sendConsolidated(payload)
          .then(() => this.fetchConsolidated(this.warehouse))
          .catch(this.$fireErrorResponse)
          .finally(() => resolve());
      });
      return promise;
    },
    sendMailToProveedor() {
      this.$fire({
        title: "¿Enviar correo a los proveedores",
        icon: "warning",
        showCancelButton: true,
        showDenyButton: true,
        showLoaderOnConfirm: true,
        showLoaderOnDeny: true,
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#d33",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Si",
        denyButtonText: "No",
        cancelButtonText: "Cancelar",
        allowOutsideClick: () => !this.$fire.isLoading(),
        preDeny: () => this.sendConsolidated("no se envio correo", false),
        preConfirm: () => this.sendConsolidated("se envio correo", true),
      }).then(({ isConfirmed, isDenied }) => {
        if (isConfirmed || isDenied) {
          return this.$fire({
            icon: "success",
            title: "Generada",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            cancelButtonText: "No",
            text: `¡Cotización generada con éxito y ${this.titleMail}!`,
            confirmButtonText: "Ir a Seguimiento de Cotizaciones",
          }).then(({ isConfirmed }) => {
            if (isConfirmed) {
              this.$router.push({
                name: "Seguimiento de cotizaciones",
                query: {
                  warehouse: this.warehouse,
                },
              });
            }
          });
        }
      });
    },
  },

  watch: {
    warehouse: {
      immediate: true,
      handler(value) {
        if (value) {
          this.loading = true;
          Promise.all([
            quotationService.fetchConsolidated(value),
            this.$http.get("catalogs/providers/"),
          ])
            .then((res) => {
              this.tableData = res[0];
              this.dataProvider = [];
              this.providers = res[1].data;
            })
            .catch(this.$fireErrorResponse)
            .finally(() => (this.loading = false));
        }
      },
    },
  },
  computed: {
    disabledQuo() {
      return (
        !this.selectedElements.length ||
        !this.paymentConditions ||
        !this.dataProvider.length ||
        !this.deliveryConditions
      );
    },
    disableRejectBtn() {
      return !this.selectedElements.length
    }
  },
  mounted() {
    Promise.all([
      warehouseService.fetchiWarehouse(),
      catalogService.fetch("services/families"),
    ])
      .then((res) => {
        this.fetchedWarehouses = res[0].sort((a, b) =>
          a.name < b.name ? -1 : 1
        );
        this.supplyFamilies = res[1];
      })
      .catch(this.$fireErrorResponse);
  },
};
</script>
<style lang="scss" scoped>
.md-layout-item {
  padding: 5px 10px;
}
.provider-form {
  z-index: 10;
}
.label-tag {
  color: #aaa !important;
  font-weight: 400;
}
.remove-tag {
  &:hover {
    cursor: pointer;
  }
}
.custom-tags {
  display: inline-block;
  &__tag {
    padding: 5px;
  }
}
.md-card,
.md-card-content,
.md-card-actions {
  border: none !important;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/QuatationsSupplies/Index.vue